export const AUTH_API =
    process.env.REACT_APP_AUTH_API || "https://api.racevision.info";

const TOKEN_KEY = "rv_token";

export function getToken() {
    return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
}

async function safeJson(res) {
    try {
        return await res.json();
    } catch {
        return {};
    }
}

export async function authFetch(path, options = {}) {
    const token = getToken();

    const headers = {
        "Content-Type": "application/json",
        ...(options.headers || {}),
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const res = await fetch(`${AUTH_API}${path}`, {
        ...options,
        headers,
    });

    const data = await safeJson(res);

    if (!res.ok) {
        const msg = data?.detail || data?.message || `HTTP ${res.status}`;
        throw new Error(msg);
    }

    return data;
}

export function loginWithDiscord() {
    window.location.href = `${AUTH_API}/api/auth/discord/login`;
}

export async function me() {
    const token = getToken();

    if (!token) {
        throw new Error("Not logged in");
    }

    return authFetch("/api/auth/me");
}

export function logout() {
    clearToken();
}